export const COMPANY_IDS = ["110", "120", "121", "140", "310"] as const;

export type CompanyID = (typeof COMPANY_IDS)[number];

export const COMPANY_NAMES = {
  110: "Vygruppen AS",
  120: "Vy Gjøvikbanen AS",
  121: "Vy Tog AS",
  310: "CargoNet AS",
  140: "Vy Tåg AB",
} as const satisfies Record<CompanyID, string>;

export const isCompanyID = (id: string): id is CompanyID =>
  COMPANY_IDS.some((companyID) => companyID === id);
